module.exports = __webpack_public_path__ + "img/wallet.efd48ac.png";